import { useContext, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Grid,
  Icon,
  Switch,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import { ClienteContext } from "../contexts/ClienteContext";
import { Margin } from "../../../../theme/styles/Utils";
import Chip from "../../../../components/basics/Chip";
import { HeaderAccordion } from "../styles/Cliente";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import Btn from "../../../../components/buttons/Btn";
import Fieldset from "../../../../components/basics/Fieldset";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

const columnsSearchDialog = [
  {
    label: "CÓD.",
    id: "id",
  },
  {
    label: "Razao",
    id: "razao",
  },
  {
    label: "Apelido",
    id: "apelido",
  },
];

let valid = false;

export default function AccordionClienteDadoGeral() {
  const [searchMatrizOpen, setSearchMatrizOpen] = useState(false);
  const {
    generalTypeSubscription,
    generalName,
    setGeneralName,
    generalFantasy,
    setGeneralFantasy,
    generalCep,
    generalNewAddress,
    setGeneralNewAddress,
    generalNumber,
    setGeneralNumber,
    generalComplement,
    setGeneralComplement,
    generalDistrict,
    setGeneralDistrict,
    generalUf,
    setGeneralUf,
    generalCounty,
    setGeneralCounty,
    generalNation,
    setGeneralNation,
    generalTelephone1,
    setGeneralTelephone1,
    generalTelephone2,
    setGeneralTelephone2,
    generalTelephone3,
    setGeneralTelephone3,
    generalEmail,
    setGeneralEmail,
    generalRg,
    setGeneralRg,
    generalIe,
    setGeneralIe,
    generalSimpleNational,
    setGeneralSimpleNational,
    generalFinalCustomer,
    setGeneralFinalCustomer,
    generalMatriz,
    setGeneralMatriz,
    generalIm,
    setGeneralIm,
    generalCcm,
    setGeneralCcm,
    generalIsuf,
    setGeneralIsuf,
    generalCheckBudget,
    setGeneralCheckBudget,
    generalCheckNfe,
    setGeneralCheckNfe,
    generalCheckFinancial,
    setGeneralCheckFinancial,
    generalActive,
    setGeneralActive,
    setGeneralSendEmail,
    generalDateInitial,
    setGeneralDateInitial,
    generalIeIndication,
    setGeneralIeIndication,
    generalWebsite,
    setGeneralWebsite,
    generalSendEmail,
    generalCpfCnpj,
    setGeneralCpfCnpj,
    generalSendHub,
    setGeneralSendHub,
    ruralProducer,
    setRuralProducer,
    validCpfCnpj,

    expanded,
    loadingInputs,
    errors,
    listUf,
    listCounty,
    listNation,
    showPlugAdd,
  } = useContext(ClienteContext);
  const { queryParams } = useContext(QueryParamsContext);
  const {
    handleChangeOpenAcordion,
    handleChangeCpfCnpj,
    handleChangeCep,
    handleChangeUf,
    clearAccordionCpf,
    clearAccordionCnpj,
  } = useClienteController();

  const handleSelectMatriz = (setSearchMatrizOpen, selectedMatriz) => {
    setSearchMatrizOpen(false);

    setGeneralMatriz(selectedMatriz[0] || null);
  };

  return (
    <>
      {searchMatrizOpen && (
        <SearchDialog
          open={searchMatrizOpen}
          setOpen={setSearchMatrizOpen}
          columns={columnsSearchDialog}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectMatriz}
          route="prouser/clientes/v1"
          title="Clientes"
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.general || false}
          onChange={() => handleChangeOpenAcordion("general")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    bgcolor={
                      !expanded.general &&
                      errors.accordions &&
                      errors.accordions.includes("general")
                        ? "red"
                        : "primary"
                    }
                    textcolor="white"
                    label="DADOS GERAIS"
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalCpfCnpj ? true : false}
                  helperText={errors.generalCpfCnpj || ""}
                  label={`CPF, CNPJ ou CÓD*`}
                  value={generalCpfCnpj}
                  setValue={setGeneralCpfCnpj}
                  onBlur={(e) => {
                    handleChangeCpfCnpj(e, "general");
                    clearAccordionCpf();
                    clearAccordionCnpj();
                  }}
                  InputProps={{
                    endAdornment: <SearchIcon onClick={() => {}} />,
                  }}
                  disabled={validCpfCnpj}
                />
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalName ? true : false}
                  helperText={errors.generalName || ""}
                  label={`${
                    !generalCpfCnpj
                      ? "Razão/Nome"
                      : generalTypeSubscription &&
                        generalTypeSubscription.value === "cpf"
                      ? "Nome"
                      : "Razão Social"
                  }*`}
                  maxLength={50}
                  value={generalName}
                  setValue={setGeneralName}
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalFantasy ? true : false}
                  helperText={errors.generalFantasy || ""}
                  label={`${
                    generalCpfCnpj === ""
                      ? "Fantasia"
                      : generalTypeSubscription &&
                        generalTypeSubscription.value === "cpf"
                      ? "Apelido"
                      : "Fantasia"
                  }*`}
                  maxLength={20}
                  value={generalFantasy}
                  setValue={setGeneralFantasy}
                />
              </Grid>
              {generalTypeSubscription &&
                generalTypeSubscription.value === "cpf" && (
                  <Grid item lg={2} md={3} sm={6} xs={12}>
                    <TextFieldErp
                      label="RG"
                      value={generalRg}
                      setValue={setGeneralRg}
                    />
                  </Grid>
                )}

              <Grid item lg={2} md={4} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalCep ? true : false}
                  helperText={errors.generalCep || ""}
                  label="CEP*"
                  maxLength={10}
                  value={generalCep}
                  onChange={(value) => handleChangeCep(value, "general")}
                  mask="cep"
                  InputProps={{
                    endAdornment: <SearchIcon onClick={() => {}} />,
                  }}
                />
              </Grid>

              <Grid item lg={6} md={4} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalNewAddress ? true : false}
                  helperText={errors.generalNewAddress || ""}
                  label="Endereço*"
                  maxLength={120}
                  value={generalNewAddress}
                  setValue={setGeneralNewAddress}
                />
              </Grid>

              <Grid item lg={1} md={2} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalNumber ? true : false}
                  helperText={errors.generalNumber || ""}
                  label="Número*"
                  maxLength={10}
                  value={generalNumber}
                  setValue={setGeneralNumber}
                />
              </Grid>

              <Grid item lg={3} md={4} sm={6} xs={12}>
                <TextFieldErp
                  label="Complemento"
                  maxLength={60}
                  value={generalComplement}
                  setValue={setGeneralComplement}
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalDistrict ? true : false}
                  helperText={errors.generalDistrict || ""}
                  label="Bairro*"
                  maxLength={60}
                  value={generalDistrict}
                  setValue={setGeneralDistrict}
                />
              </Grid>

              <Grid item lg={3} md={2} sm={6} xs={12}>
                <SelectErp
                  error={errors.generalNation ? true : false}
                  helperText={errors.generalNation || ""}
                  loading={loadingInputs.listNation || false}
                  label="País*"
                  value={generalNation}
                  setValue={setGeneralNation}
                  optionsList={listNation}
                  descriptionField="descricao"
                />
              </Grid>

              <Grid item lg={2} md={3} sm={6} xs={12}>
                <SelectErp
                  error={errors.generalUf ? true : false}
                  helperText={errors.generalUf || ""}
                  loading={loadingInputs.listUf || false}
                  label="Estado*"
                  value={generalUf}
                  onChange={(e) =>
                    handleChangeUf(e, setGeneralUf, setGeneralCounty)
                  }
                  optionsList={listUf}
                  descriptionField="estado"
                />
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <SelectErp
                  error={errors.generalCounty ? true : false}
                  helperText={errors.generalCounty || ""}
                  loading={loadingInputs.listCounty || false}
                  label="Municipio*"
                  value={generalCounty}
                  setValue={setGeneralCounty}
                  optionsList={
                    generalUf
                      ? listCounty.filter(
                          (opt) => opt.estado_codigo === generalUf.codibge
                        )
                      : []
                  }
                  descriptionField="municipio"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalTelephone1 ? true : false}
                  helperText={errors.generalTelephone1 || ""}
                  label="Telefone 1"
                  value={generalTelephone1}
                  setValue={setGeneralTelephone1}
                  mask="cel-phone"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalTelephone2 ? true : false}
                  helperText={errors.generalTelephone2 || ""}
                  label="Telefone 2"
                  value={generalTelephone2}
                  setValue={setGeneralTelephone2}
                  mask="cel-phone"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.generalTelephone3 ? true : false}
                  helperText={errors.generalTelephone3 || ""}
                  label="Telefone 3"
                  value={generalTelephone3}
                  setValue={setGeneralTelephone3}
                  mask="cel-phone"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <SelectErp
                  loading={false}
                  label="Indicação de IE"
                  value={generalIeIndication}
                  setValue={setGeneralIeIndication}
                  optionsList={[
                    { label: "Contribuinte ICMS", value: 1, codigo: "1" },
                    { label: "Contribuinte Isento", value: 0, codigo: "2" },
                    { label: "Não Contribuinte", value: 0, codigo: "9" },
                  ]}
                  descriptionField="label"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  label="Inscrição Estadual"
                  maxLength={20}
                  value={generalIe}
                  setValue={setGeneralIe}
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  label={
                    queryParams.idversao !== "26"
                      ? "Inscrição municipal"
                      : "Inscrição Municipal Imobiliária"
                  }
                  maxLength={15}
                  value={generalIm}
                  setValue={setGeneralIm}
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  label={
                    queryParams.idversao !== "26"
                      ? "CCM"
                      : "Inscrição Municipal Mobiliária/CCM"
                  }
                  maxLength={30}
                  value={generalCcm}
                  setValue={setGeneralCcm}
                />
              </Grid>

              {generalTypeSubscription &&
                generalTypeSubscription.value === "cnpj" &&
                valid && (
                  <Grid item lg={3} md={3} sm={6} xs={12} container spacing={1}>
                    <Grid item xs>
                      <TextFieldErp
                        variant="filled"
                        disabled
                        label="Matriz"
                        error={errors.generalMatriz ? true : false}
                        helperText={errors.generalMatriz || ""}
                        value={generalMatriz ? generalMatriz.apelido || "" : ""}
                      />
                    </Grid>

                    <Grid item flex={1}>
                      <Btn
                        height="48px"
                        onClick={() => {
                          setSearchMatrizOpen(true);
                        }}
                        label={<Icon>search</Icon>}
                      />
                    </Grid>
                  </Grid>
                )}

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  label="Inscrição Suframa"
                  maxLength={9}
                  value={generalIsuf}
                  setValue={setGeneralIsuf}
                />
              </Grid>

              <Grid item lg={2} md={3} sm={6} xs={12}>
                <TextFieldErp
                  label="Cliente Desde"
                  maxLength={50}
                  defaultValue=""
                  value={generalDateInitial}
                  setValue={setGeneralDateInitial}
                  type="date"
                />
              </Grid>

              <Grid item lg={4} md={3} sm={6} xs={12}>
                <TextFieldErp
                  label="Site"
                  maxLength={50}
                  value={generalWebsite}
                  setValue={setGeneralWebsite}
                />
              </Grid>
              <Grid item lg={6} sm={8} container spacing={2}>
                <Grid item>
                  <FormControlLabel
                    value="end"
                    control={
                      <Switch
                        checked={generalFinalCustomer}
                        onChange={() =>
                          setGeneralFinalCustomer((current) => !current)
                        }
                        color="primary"
                      />
                    }
                    label="Consumidor Final"
                    labelPlacement="end"
                  />
                </Grid>

                <Grid item>
                  <FormControlLabel
                    value="end"
                    control={
                      <Switch
                        checked={ruralProducer}
                        onChange={() => setRuralProducer((current) => !current)}
                        color="primary"
                      />
                    }
                    label="Produtor Rural"
                    labelPlacement="end"
                  />
                </Grid>

                <Grid item>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={generalActive}
                        onChange={() => setGeneralActive((current) => !current)}
                        color="primary"
                      />
                    }
                    label="Ativo"
                    labelPlacement="end"
                  />
                </Grid>
                {showPlugAdd && (
                  <Grid item>
                    <Tooltip title="Envia os dados do cliente para os cadastros de Empresas do Portal, Folha, Fiscal e Contábil.">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={generalSendHub}
                            onChange={() =>
                              setGeneralSendHub((current) => !current)
                            }
                            color="primary"
                          />
                        }
                        label="Habilitar cadastro para soluções QYON"
                        labelPlacement="end"
                      />
                    </Tooltip>
                  </Grid>
                )}
              </Grid>

              {generalTypeSubscription &&
                generalTypeSubscription.value === "cnpj" && (
                  <Grid item xs={12}>
                    <FormControlLabel
                      value="end"
                      control={
                        <Switch
                          checked={generalSimpleNational}
                          onChange={() =>
                            setGeneralSimpleNational((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="Optante pelo simples nacional"
                      labelPlacement="end"
                    />
                  </Grid>
                )}

              <Margin top="90" />
              <Grid item container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Fieldset
                    titulo="Envio de Email"
                    bgcolor="secondary"
                    textcolor="black"
                  >
                    <Grid container spacing={2}>
                      <Grid item lg={4} md={6} sm={6} xs={12}>
                        <TextFieldErp
                          label="E-mail"
                          maxLength={60}
                          value={generalEmail}
                          setValue={setGeneralEmail}
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          value="end"
                          control={
                            <Switch
                              checked={generalCheckNfe}
                              onChange={() =>
                                setGeneralCheckNfe((current) => !current)
                              }
                              color="primary"
                            />
                          }
                          label="NF-e"
                          labelPlacement="end"
                        />
                      </Grid>

                      <Grid item>
                        <FormControlLabel
                          value="end"
                          control={
                            <Switch
                              checked={generalCheckFinancial}
                              onChange={() =>
                                setGeneralCheckFinancial((current) => !current)
                              }
                              color="primary"
                            />
                          }
                          label="Financeiro"
                          labelPlacement="end"
                        />
                      </Grid>

                      <Grid item>
                        <FormControlLabel
                          value="end"
                          control={
                            <Switch
                              checked={generalCheckBudget}
                              onChange={() =>
                                setGeneralCheckBudget((current) => !current)
                              }
                              color="primary"
                            />
                          }
                          label="Orçamento/Venda"
                          labelPlacement="end"
                        />
                      </Grid>

                      <Grid item lg={3}>
                        <FormControlLabel
                          value="end"
                          control={
                            <Switch
                              checked={generalSendEmail}
                              onChange={() =>
                                setGeneralSendEmail((current) => !current)
                              }
                              color="primary"
                            />
                          }
                          label="Enviar e-mail de notificação de contas a vencer"
                          labelPlacement="end"
                        />
                      </Grid>
                    </Grid>
                  </Fieldset>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
